export const triggeringYandexMetric = {
    openFormImage: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'OpenFormImage');
        }
    },
    submitFormImage: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'SubmitFormImage');
        }
    },
    openFormQuestion: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'OpenFormQuestion');
        }
    },
    submitFormQuestion: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'SubmitFormQuestion');
        }
    },
    submitOldUploadFormIntroduction: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'submitOldUploadFormIntroduction');
        }
    },
    submitOldUploadFormToolChoose: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'submitOldUploadFormToolChoose');
        }
    },
    submitNewUploadForm: () => {
        if (window.ym && window.currentMetrikaId) {
            window.ym(window.currentMetrikaId, 'reachGoal', 'submitNewUploadForm');
        }
    },
};